import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { InputControl } from '@si-armes/dsfr-react';
import PropTypes from 'prop-types';
import { getMessageErreurChampManquant } from 'utils/utils';

const CaptchaEtatInput = ({ setInfoCaptchaEtat }) => {
    const { register, formState, getValues, watch } = useForm({
        mode: 'onChange',
    });

    useEffect(() => {
        setInfoCaptchaEtat({ code: getValues('captchaCode') });
    }, [watch('captchaCode')]);

    return (
        <InputControl
            id="captchaCode"
            label="Saisissez les caractères de l'image *"
            minLength="6"
            maxLength="9"
            required
            type="text"
            {...register('captchaCode', {
                required: getMessageErreurChampManquant('code'),
            })}
            state={formState.errors?.captchaFormulaireExtInput ? 'error' : null}
            message={formState.errors?.captchaFormulaireExtInput?.message}
        />
    );
};

CaptchaEtatInput.propTypes = {
    setInfoCaptchaEtat: PropTypes.func.isRequired,
};

export default CaptchaEtatInput;
